import { t } from 'i18next'
import React, { ReactElement } from 'react'
import Button from 'ui/atoms/Button/Button'
import { downloadAsJSON } from './Optimizations.helper'

type DownloadJSONButtonProps = {
  content: unknown
  filename: string
}

export default function DownloadJSONButton({ content, filename }: DownloadJSONButtonProps): ReactElement {
  return (
    <div className="my-2">
      <Button icon="fal fa-download" secondary onClick={() => downloadAsJSON(content, filename)} disabled={!content}>
        {t('Download JSON')}
      </Button>
    </div>
  )
}
